import styled from 'styled-components';

export const Content = styled.div``;

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: var(--primary-dark);
  margin: 20px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Div = styled.div`
  &.active {
    color: var(--primary-green);
  }
  &.inactive {
    color: #ff646480;
  }
  &.captal {
    text-transform: capitalize;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f8fc;
  padding: 7px 10px;
  border-radius: 12px;
  margin: 0 15px;
`;

export const FilterButoons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Button = styled.button`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--white);
  background: #8a93ac;
  min-width: 68px;
  border: none;
  height: 28px;
  border-radius: 8px;
  padding: 0 8px;

  &.active {
    background: var(--primary-dark-two);
  }
`;

export const Icon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #616e84;
  line-height: 0;
  border-radius: 40px;
  margin: auto;
  /* padding: 10px; */
`;

export const Image = styled.img`
  max-width: 100%;
  padding: 10px;
`;

export const TableCon = styled.div`
  overflow-x: auto;
  /* max-width: 100%; */
  width: 100%;
  position: relative;
  min-height: 200px;
`;

export const Table = styled.table`
  width: 100%;
  /* min-width: max-content; */
`;

export const Thead = styled.thead`
  padding-bottom: 5px;
  position: relative;

  &.one {
    border-bottom: 1px solid #f0f0f0;
  }

  &.two {
    background: #fafafa;
    border-radius: 8px 8px 0px 0px;

    th {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 100%;
      color: var(--primary-two);
    }
  }

  /* &::before {
    content: "";
    width: 100%;
    height: 1px;
    background: #e2e8f0;
    position: absolute;
    bottom: 0;
  }

  &:last-child {
    border-bottom: none;

    &::before {
      opacity: 0;
    }
  } */
`;

export const Tbody = styled.tbody``;

export const Td = styled.td`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: #2d3748;
  padding: 14px 20px;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #f0f0f0;
  position: relative;

  /* &::before {
    content: "";
    width: 100%;
    height: 1px;
    background: #e2e8f0;
    position: absolute;
    bottom: 0;
  } */

  &:last-child {
    border-bottom: none;

    /* &::before {
      opacity: 0;
    } */
  }
  &.active {
    td {
      color: var(--primary);
      font-weight: 700;
    }
  }
`;

export const HeaderTh = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: Poppins;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0em;
  text-wrap: nowrap;
  min-width: 160px;

  svg {
    margin-right: 5px;
  }
`;

export const Th = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #4d4d4d;
  padding: 14px 20px;
  /* font-family: DMSans; */
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
`;

export const Status = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 100px;
  height: 24px;
  margin: 0 auto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;

  &.Success {
    background: rgba(51, 183, 80, 0.1);
    color: var(--primary-green);
  }

  &.Rejected {
    background: rgba(183, 51, 51, 0.1);
    color: var(--danger);
  }
`;

export const TableLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 0 0 10px #000; */

  svg {
    width: 150px;
    height: 150px;
  }
`;

export const Loader = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: max-content;
  height: max-content;
`;
